// Function to categorize fonts into separate arrays based on their categories
export const categorizeFonts = (fonts: Font[]) => {
  return fonts.reduce((acc: { [key: string]: Font[] }, font) => {
    // Initialize the category array if it doesn't exist
    if (!acc[font.category]) {
      acc[font.category] = []
    }

    // Push the font to the category array
    acc[font.category].push(font)
    return acc
  }, {})
}
